import { render, staticRenderFns } from "./VEmployerNotifications.vue?vue&type=template&id=24c0ab3f&scoped=true&lang=pug"
import script from "./VEmployerNotifications.vue?vue&type=script&lang=ts"
export * from "./VEmployerNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c0ab3f",
  null
  
)

export default component.exports